// JsFromRoutes CacheKey d34d686ff0839b97fd6c93861f618797
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  linkExpired: /* #__PURE__ */ definePathHelper('get', '/gift/link-expired'),
  resendExpiredLink: /* #__PURE__ */ definePathHelper('post', '/gift/link-expired/resend'),
  landing: /* #__PURE__ */ definePathHelper('get', '/gift/landing/:id/:token'),
  thankYouForm: /* #__PURE__ */ definePathHelper('get', '/gift/thank_you/:id/:token'),
  fetchRecipientGift: /* #__PURE__ */ definePathHelper('get', '/gift/fetch_recipient_gift/:id/:token'),
  defaultLocation: /* #__PURE__ */ definePathHelper('get', '/consumer/recipient_gifts/default_location'),
  giftCodeLookup: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/gift_code_lookup'),
  validateBankRoutingNumber: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/validate_bank_routing_number'),
  validateBankAccountNumber: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/validate_bank_account_number'),
  createOtp: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/create_otp'),
  validateOtp: /* #__PURE__ */ definePathHelper('put', '/consumer/recipient_gifts/validate_otp'),
  savedRedemptionMethod: /* #__PURE__ */ definePathHelper('get', '/consumer/recipient_gifts/saved_redemption_method'),
  logRedemptionModalOpened: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/log_redemption_modal_opened'),
  redeemGiftly: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/redeem_giftly'),
  cancelPendingRedemption: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/cancel_pending_redemption'),
  resendRedemptionVerification: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/resend_redemption_verification'),
  activateGiftCard: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/activate_gift_card'),
  sendThankYouNote: /* #__PURE__ */ definePathHelper('post', '/consumer/recipient_gifts/send_thank_you_note'),
  lookup: /* #__PURE__ */ definePathHelper('get', '/entercode'),
  visaCardManage: /* #__PURE__ */ definePathHelper('get', '/card/manage/:card_id/:token'),
  fetchVisaCardTransactions: /* #__PURE__ */ definePathHelper('get', '/card/fetch_transactions'),
  setCardPin: /* #__PURE__ */ definePathHelper('post', '/card/set_card_pin'),
}
